// HTML Include 기능
function includeHTML() {
  var elements, i, element, file, xhttp;
  
  // data-include 속성을 가진 모든 요소 찾기
  elements = document.querySelectorAll("[data-include]");
  
  for (i = 0; i < elements.length; i++) {
    element = elements[i];
    // data-include 속성에서 파일 경로 가져오기
    file = element.getAttribute("data-include");
    
    if (file) {
      // AJAX 요청으로 파일 내용 가져오기
      xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4) {
          if (this.status == 200) {
            // 성공시 내용을 요소에 삽입
            element.innerHTML = this.responseText;
          }
          if (this.status == 404) {
            // 파일을 찾을 수 없는 경우
            element.innerHTML = "Page not found.";
          }
          // data-include 속성 제거
          element.removeAttribute("data-include");
          // 재귀적으로 다시 실행 (중첩 include 지원)
          includeHTML();
        }
      };
      xhttp.open("GET", file, true);
      xhttp.send();
      return; // 한 번에 하나씩 처리
    }
  }
}

// 페이지 로드 완료 후 include 실행
document.addEventListener("DOMContentLoaded", function() {
  includeHTML();
});